// extracted by mini-css-extract-plugin
module.exports = {"wishlist":"product-wishlist-button_wishlist__EMjuo","clipPath":"product-wishlist-button_clipPath__FePew","active":"product-wishlist-button_active__9vFRV"};